import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AdminPageHeaderComponent } from '../admin-page-header/admin-page-header.component';

export interface AdminDetailTab {
  route: string;
  labelKey: string;
  icon: string;
  exact?: boolean;
}

@Component({
  selector: 'app-admin-detail-shell',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, AdminPageHeaderComponent],
  templateUrl: './admin-detail-shell.component.html',
  styleUrl: './admin-detail-shell.component.scss',
})
export class AdminDetailShellComponent {
  @Input() titleKey = '';
  @Input() descriptionKey = '';
  @Input() backLink: string | any[] = '';
  @Input() showBack = true;
  @Input() contextLabelKey = '';
  @Input() contextValue = '';
  @Input() tabs: AdminDetailTab[] = [];
}
